import React from 'react';
import { useSearchParams } from 'react-router';

import { FormContainer } from '@eika-kortbetjening/form-container';
import { PinChangeOption } from '@eika-kortbetjening/pin-change-decision-form';
import { RadioButtonOption } from '@eika-kortbetjening/pin-change-decision-form/src/types';
import { Loader } from '@eika/loader';
import { RadioButtonPanels } from '@eika/radio-button';

import { useAccountFromQueryParam } from '@/react-query/hooks/query/use-account';

import { useSession } from '@components/app/Session';
import Footer from '@components/footer/Footer';
import { SearchParams } from '@domain/app/SearchParams';
import useText from '@hooks/use-text';

type PinDecisionProps = {
    toNextStep(): void;
};

export const OrderCardFormNewPinDecisionContainer = ({ toNextStep }: PinDecisionProps) => {
    const user = useSession()?.user?.userId;
    const text = useText();

    const accountQuery = useAccountFromQueryParam();
    const [searchParams, setSearchParams] = useSearchParams([[SearchParams.PIN_DECISION, PinChangeOption.KEEP_PIN]]);

    const userIsOwnerOfTheAccount = accountQuery.data?.owner === user;

    const selectedOption = searchParams.get(SearchParams.PIN_DECISION) || PinChangeOption.KEEP_PIN;

    const options: RadioButtonOption[] = [
        {
            id: PinChangeOption.KEEP_PIN,
            value: PinChangeOption.KEEP_PIN,
            label: text.keepPinRadioOption,
        },
        {
            id: PinChangeOption.CHANGE_PIN,
            value: PinChangeOption.CHANGE_PIN,
            label: text.changePinRadioOption,
        },
    ];

    if (accountQuery.isPending) {
        return <Loader />;
    }

    if (accountQuery.isError) {
        return null;
    }

    return (
        <FormContainer>
            <FormContainer.Content>
                <RadioButtonPanels
                    label={userIsOwnerOfTheAccount ? text.orderCardTitle : text.orderCardUserIsNotOwnerTitle}
                    sublabel={text.pinChangeDecisionFormTitle}
                    options={options}
                    selectedOption={selectedOption}
                    onChange={(value: string) =>
                        setSearchParams(
                            (prev) => {
                                prev.set(SearchParams.PIN_DECISION, value);
                                return prev;
                            },
                            { replace: true },
                        )
                    }
                />
            </FormContainer.Content>
            <FormContainer.Footer>
                <Footer next={toNextStep} canGoBack />
            </FormContainer.Footer>
        </FormContainer>
    );
};
